const StoreGroup = () => import(/* webpackChunkName: "StoreGroup" */ '@/views/StorePage/storeGroup')
const GroupManagement = () => import(/* webpackChunkName: "GroupManagement" */ '@/views/StorePage/groupManagement')
const storePageRouter = [
  {
    path: '/store/storeGroup',
    component: StoreGroup,
    meta: {
      scrollY: 0,
      title: 'Store Group'
    }
  },
  {
    path: '/store/groupManagement',
    component: GroupManagement,
    meta: {
      scrollY: 0,
      title: 'Group Management'
    }
  }
]

export default storePageRouter
